import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import PaymentIcon from "@mui/icons-material/Payment";

const StyledHeader = styled(Box)(({}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledPlansIcon = styled(PaymentIcon)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const PlansHeader = ({name}) => {

  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
         {name}
        </Typography>
        <StyledPlansIcon />
      </Box>
    </StyledHeader>
  );
};

export default PlansHeader;
